import type {
  ExtendedConstraints,
  CapabilityConfig,
  EventHandlerCb,
} from '../../types';
import { hasOnlyKeysFromSet } from '../../utils';

export const id = 'navigation-interception';

export enum Actions {
  Add = 'navigation-interception:add',
  Remove = 'navigation-interception:remove',
  ManualTrigger = 'navigation-interception:manual-trigger',
}

export enum Events {
  ManualTriggerResolved = 'navigation-interception:manual-trigger-resolved',
}

export type Config = CapabilityConfig & {
  type: typeof id;
};

export enum StatusIcon {
  Check = 'check',
  Negative = 'negative',
  Alert = 'alert',
  Informative = 'informative',
  Spinner = 'spinner',
}

export type NavigationAddPayload = {
  title: string;
  description: string;
  stayButtonText: string;
  leaveButtonText: string;
  statusIcon?: StatusIcon | undefined;
  id: string;
  allowClientSideNavigation?: boolean;
};

export type NavigationRemovePayload = Pick<NavigationAddPayload, 'id'>;

export type NavigationManualTriggerPayload = Pick<NavigationAddPayload, 'id'>;

export type NavigationDecision = 'stay' | 'leave';

export type NavigationManualTriggerResolvedPayload = {
  id: string;
  decision: NavigationDecision;
};

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  actionPayloadTuple:
    | [Actions.Add, NavigationAddPayload]
    | [Actions.Remove, NavigationRemovePayload]
    | [Actions.ManualTrigger, NavigationManualTriggerPayload];
  eventPayloadTuple: [
    Events.ManualTriggerResolved,
    NavigationManualTriggerResolvedPayload,
  ];
  eventHandlerTuple: [
    Events.ManualTriggerResolved,
    EventHandlerCb<NavigationManualTriggerResolvedPayload>,
  ];
}>;

const VALID_CONFIG_KEYS = ['type'] as const;
export function isValidConfig(config: CapabilityConfig): config is Config {
  if (!hasOnlyKeysFromSet(config, VALID_CONFIG_KEYS)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
